import { useParams } from "react-router";
import { z } from "zod";
import { OrgCategory } from "../../../generated/core-api";

export const orgCategorySchema = z.enum([
  "public",
  "internal",
  "personal",
]) as z.ZodType<OrgCategory>;

export const orgRouteParamsSchema = z.object({
  category: orgCategorySchema,
  id: z.string(),
});

export const orgCategoryRouteParamsSchema = z.object({
  category: orgCategorySchema,
});

export type OrgRouteParams = z.infer<typeof orgRouteParamsSchema>;

export type OrgCategoryRouteParams = z.infer<
  typeof orgCategoryRouteParamsSchema
>;

/**
 * Hook that parses and validates org route parameters
 * Returns the validated category and id parameters from the current route
 */
export function useOrgParams() {
  const params = useParams();
  const parsedParams = orgRouteParamsSchema.parse(params);

  return parsedParams;
}

/**
 * Hook that parses and validates only the org category route parameter
 * Returns the validated category parameter from the current route
 */
export function useOrgCategoryParams() {
  const params = useParams();
  const parsedParams = orgCategoryRouteParamsSchema.parse(params);

  return parsedParams;
}
